import { apiEndpoints } from "core/api/apiEndpoints";
import { httpRequest } from "core/api/httpRequest";

// guidance category api
const getGuidanceCategories = () => {
  return httpRequest(apiEndpoints.getGuidanceCategory, "get");
};

// Get api for all guidance articles
const getGuidanceAll = () => {
  return httpRequest(apiEndpoints.getGuidanceAll, "get");
};

//get api for fetch articles based upon categories
const getGuidanceArticlesBasedOnCategories = (payload: any) => {
  // post api call
  return httpRequest(apiEndpoints.guidanceFilterArticles, "post", payload);
};
const getGuidanceArticlesBasedOnCategoriesNew = (catId: string) => {
  // post api call
  const url = {
    url: apiEndpoints.guidanceFilterArticles.url + catId,
    isMock: apiEndpoints.guidanceFilterArticles.isMock,
  };
  return httpRequest(url, "get");
};

//article progress api
const saveGuidanceProgress = (payload: any) => {
  return httpRequest(apiEndpoints.guidanceProgress, "post", payload);
};

//video status api
const saveVideoProgress = (payload: any) => {
  return httpRequest(apiEndpoints.saveVideoProgress, "post", payload);
};
export {
  getGuidanceCategories,
  getGuidanceAll,
  getGuidanceArticlesBasedOnCategories,
  saveGuidanceProgress,
  saveVideoProgress,
  getGuidanceArticlesBasedOnCategoriesNew,
};
